module.exports = __webpack_public_path__ + "static/media/logo_mobile_blue.b1d694af.svg";